(() => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const setupCarousel = (carousel) => {
    if (carousel.dataset.reviewsInit === "1") return;
    const track = carousel.querySelector("[data-reviews-track]");
    if (!track) return;

    const base = track.innerHTML;
    if (!base.trim()) return;

    const concatCopies = (n) => {
      let html = "";
      for (let i = 0; i < n; i++) html += base;
      return html;
    };

    let repeats = 2;
    track.innerHTML = concatCopies(repeats);
    void carousel.offsetWidth;

    while (carousel.scrollWidth <= carousel.clientWidth + 8 && repeats < 14) {
      repeats += 1;
      track.innerHTML = concatCopies(repeats);
      void carousel.offsetWidth;
    }

    track.dataset.reviewRepeatCount = String(repeats);
    carousel.dataset.reviewsInit = "1";

    let rafId = null;
    let dragging = false;
    let lastX = 0;
    let movedWhileDragging = false;
    const autoplayEnabled = !prefersReducedMotion;
    const speedPxPerFrame = 0.38;
    const dragThreshold = 4;

    const loopWidth = () => {
      const n = Math.max(1, parseInt(track.dataset.reviewRepeatCount, 10) || repeats);
      return Math.max(track.scrollWidth / n, 1);
    };

    const canScroll = () => carousel.scrollWidth > carousel.clientWidth + 2;

    const step = () => {
      if (autoplayEnabled && !dragging && !document.hidden && canScroll()) {
        const cap = loopWidth();
        carousel.scrollLeft += speedPxPerFrame;
        if (carousel.scrollLeft >= cap) {
          carousel.scrollLeft -= cap;
        }
      }
      rafId = requestAnimationFrame(step);
    };

    const onPointerDown = (event) => {
      dragging = true;
      carousel.classList.add("is-dragging");
      lastX = event.clientX;
      movedWhileDragging = false;
      carousel.setPointerCapture(event.pointerId);
    };

    const onPointerMove = (event) => {
      if (!dragging) return;
      const delta = event.clientX - lastX;
      if (Math.abs(delta) > dragThreshold) movedWhileDragging = true;
      carousel.scrollLeft -= delta;
      lastX = event.clientX;

      const cap = loopWidth();
      if (carousel.scrollLeft < 0) {
        carousel.scrollLeft += cap;
      } else if (carousel.scrollLeft >= cap) {
        carousel.scrollLeft -= cap;
      }
    };

    const onPointerUp = (event) => {
      dragging = false;
      carousel.classList.remove("is-dragging");
      if (carousel.hasPointerCapture(event.pointerId)) {
        carousel.releasePointerCapture(event.pointerId);
      }
      if (movedWhileDragging) {
        carousel.dataset.dragged = "true";
        setTimeout(() => {
          delete carousel.dataset.dragged;
        }, 0);
      }
    };

    carousel.addEventListener("pointerdown", onPointerDown);
    carousel.addEventListener("pointermove", onPointerMove);
    carousel.addEventListener("pointerup", onPointerUp);
    carousel.addEventListener("pointercancel", onPointerUp);
    carousel.addEventListener("click", (event) => {
      if (carousel.dataset.dragged === "true") {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(step);
  };

  const initIn = (root) => {
    (root || document).querySelectorAll("[data-reviews-carousel]").forEach(setupCarousel);
  };

  initIn(document);
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target) initIn(event.target);
  });
})();
